import tw from 'twin.macro';

export const Wrapper = tw.div`
   w-full flex flex-col items-center gap-6 
`;
